module.exports = __webpack_public_path__ + "static/img/bg.9f9e5a3d.jpg";